import React, {Component} from 'react';

import { connect } from 'react-redux'
import Support from './components/Support/Support'

import {
  fetchSlimAccount
} from 'broker/redux/account'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SupportContainer extends Component {

    constructor(props) {
      super(props)
    }

    componentWillMount() {
      this.props.dispatch(fetchSlimAccount())
    }

    render() {
      return <Support {...this.props} />
    }
}

export default connect((state) => ({ account: state.account }), mapDispatchToProps)(SupportContainer)
